module.exports = __webpack_public_path__ + "880a377f28ffe9d9b38fbaa96f62fc47.png";